import axios from "axios"
import { IConsultantDEsuiviModel } from "@common-models/*"
import { CONST_API_BUSINESS_CONSULTANT_GET_DE_SUIVI_ENDPOINT } from "../../../../endpoints"

export function getDemandeEmbaucheSuivi(consultant_id: number) {
     return axios.get<IConsultantDEsuiviModel[]>(CONST_API_BUSINESS_CONSULTANT_GET_DE_SUIVI_ENDPOINT(consultant_id))
}
